













































































































































































import { Vue, Component } from "vue-property-decorator";
import moment from "moment";

// @ts-ignore
import wxlogin from "vue-wxlogin";

@Component({
  components: {
    wxlogin
  }
})
export default class extends Vue {
  formItemLayout: any = {
    labelCol: { span: 4 },
    wrapperCol: { span: 16 }
  };

  formTailLayout: any = {
    labelCol: { span: 4 },
    wrapperCol: { span: 8, offset: 4 }
  };

  form!: any;

  resetForm!: any;

  year: string = moment().format("YYYY");

  modalVisible = false;

  confirmDirty = false;

  btnText = "获取验证码";

  btnDisabled = false;

  captcha = "";

  idkey = "";

  showWxLogin = false;

  showWxLogin1 = false;

  appid = "wxeb9b676a88d32a0b";

  scope = "snsapi_login";

  redirecturi = "https://wechat.api.taisam.cn/v1/wxlogin/admin?type=admin";

  handleConfirmBlur(e: any) {
    const { value } = e.target;
    this.confirmDirty = this.confirmDirty || !!value;
  }

  compareToFirstPassword(rule: any, value: any, callback: (...args: any[]) => any) {
    const form = this.resetForm;
    if (value && value !== form.getFieldValue("password")) {
      callback("两次输入密码不一致");
    } else {
      callback();
    }
  }

  validateToNextPassword(rule: any, value: any, callback: (...args: any[]) => any) {
    const form = this.resetForm;
    if (value && this.confirmDirty) {
      form.validateFields(["confirm_password"], { force: true });
    }
    callback();
  }

  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.resetForm = this.$form.createForm(this);
  }

  showResetPwd() {
    this.modalVisible = true;
  }

  getCaptcha() {
    this.resetForm.validateFields(["username"], { force: true }, async (err: any, values: any) => {
      if (!err) {
        const res = await this.$store.dispatch("user/getCaptcha", values);
        if (res && res.Message === "success") {
          this.$message.success(res.Message);
          // 倒计时
          let timer = 10;

          const t = setInterval(() => {
            this.setBtnText(`${timer}秒后重新获取`);
            if (timer === 0) {
              // 设置按钮文本
              this.setBtnText("获取验证码");
              clearInterval(t);
            }
            timer -= 1;
          }, 1000);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  setBtnText(txt: string) {
    this.btnText = txt;
    if (txt === "获取验证码") {
      this.btnDisabled = false;
    } else {
      this.btnDisabled = true;
    }
  }

  handleResetPwd(e: any) {
    e.preventDefault();
    this.resetForm.validateFields(async (err: any, values: any) => {
      if (!err) {
        const res = await this.$store.dispatch("user/resetPwd", values);
        if (res && res.Message === "success") {
          this.$message.success(res.Message);
          this.modalVisible = false;
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  handleCancelResetPwd(e: any) {
    e.preventDefault();
    this.modalVisible = false;
  }

  handleSubmit(e: any) {
    e.preventDefault();
    this.form.validateFields(async (err: any, values: any) => {
      if (!err) {
        const res = await this.$store.dispatch("user/login", {
          idKey: this.idkey,
          ...values
        });
        // console.log(res)
        if (res && res.Message === "success") {
          const redirect = decodeURIComponent((this.$route.query.redirect as string) || "/");

          this.$router.push({
            path: redirect
          });
          // this.$message.success("登录成功");
        } else {
          // 刷新验证码
          this.refreshCaptcha();
          this.$message.error(res.Message);
        }
      }
    });
  }

  refreshCaptcha() {
    this.$store.dispatch("user/logincaptcha", {}).then((res: any) => {
      // console.log(res)
      this.captcha = res.Data.base64Image;
      this.idkey = res.Data.idKey;
    });
  }

  mounted() {
    // console.log(window.location.host);
    if (window.localStorage.getItem("token")) {
      window.location.href = "/";
      return;
    }
    if (
      window.location.host === "adminweb.taisam.cn" ||
      window.location.host === "admin-yuyuesports-1257401801.cos-website.ap-shanghai.myqcloud.com"
    ) {
      this.showWxLogin = true;
    } else if (window.location.host === "192.168.1.5:8010") {
      // 本地的正式服
      this.showWxLogin1 = true;
      this.redirecturi = "https://wechat.api.taisam.cn/v1/wxlogin/admin?type=adminlocal";
    }
    this.refreshCaptcha();
  }
}
